import script from "./RadioBtn.vue?vue&type=script&setup=true&lang=js"
export * from "./RadioBtn.vue?vue&type=script&setup=true&lang=js"

import "./RadioBtn.vue?vue&type=style&index=0&id=64c81862&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64c81862"]])

export default __exports__